import { render, staticRenderFns } from "./RAMSSubmission.vue?vue&type=template&id=0b926473&"
import script from "./RAMSSubmission.vue?vue&type=script&lang=js&"
export * from "./RAMSSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports